export enum AnalyticsEventName {
  PageLoad = 'page_load',
  ItemClick = 'item_click',
}
